module.exports = __webpack_public_path__ + "img/chart.0c6ad66.png";